import cx from 'classnames'
import type React from 'react'

import css from './Placeholder.module.scss'

type Props = {
  onClick: () => void
  disabled?: boolean
  className?: string
  size: 'small' | 'medium' | 'large'
  children?: React.ReactNode
}

const Placeholder: React.FC<Props> = ({
  className,
  disabled,
  size,
  children,
  onClick,
}) => (
  <div
    className={cx(css.container, className, css[size], {
      [css.disabled]: disabled,
    })}
    onClick={onClick}
  >
    {children}
  </div>
)

export default Placeholder
